import React from 'react';
import { formatDate, localizedValue } from './nationalizationViewModel';

export default function NationalizationRuleUpdates({ updates = [], language, acknowledgingId, t, onAcknowledge }) {
  const unacknowledged = (Array.isArray(updates) ? updates : []).filter(
    (update) => update?.acknowledged !== true && !update?.acknowledged_at
  );
  if (!unacknowledged.length) return null;

  return (
    <section className="nationalization-rule-updates" aria-label={t('notifications.ruleUpdatesTitle', 'Nationalization rule updates')}>
      {unacknowledged.map((update) => {
        const updateId = `${update.rule_id || update.code}:${update.rule_version || ''}`;
        const source = update.source || {};
        return (
          <article key={updateId}>
            <i className="fa-solid fa-scale-balanced" aria-hidden="true" />
            <div>
              <strong>{localizedValue(update, language, 'title') || t('notifications.ruleUpdated', 'A nationalization rule affecting your company was updated.')}</strong>
              <p>{localizedValue(update, language, 'message') || localizedValue(update, language, 'impact') || t('notifications.ruleEffectiveDate', 'Effective {{date}}', {
                date: formatDate(update.effective_from, language)
              })}</p>
              {(source.url || update.effective_from) && (
                <small>
                  {update.effective_from && t('notifications.ruleEffectiveDate', 'Effective {{date}}', {
                    date: formatDate(update.effective_from, language)
                  })}
                  {source.url && (
                    <a href={source.url} target="_blank" rel="noreferrer">
                      {localizedValue(source, language) || source.reference || t('actions.openOfficialSource', 'Open official source')}
                    </a>
                  )}
                </small>
              )}
            </div>
            {onAcknowledge && (
              <button type="button" disabled={acknowledgingId === updateId} onClick={() => onAcknowledge(update, updateId)}>
                {acknowledgingId === updateId
                  ? t('actions.saving', 'Saving...')
                  : t('actions.acknowledge', 'Acknowledge')}
              </button>
            )}
          </article>
        );
      })}
    </section>
  );
}
